/**
 * profile-web-ui 样式&组件适配规则
 * mobile端：<480px时自适应字体和边距；>=480px时(包含切换横屏)按照主体内容480展示，两侧留白
 * pad端：=768px展示mobile样式和组件；>768px按照主体内容480展示，两侧留白
 * pc端：>768px展示pc样式和组件；<=768px展示mobile样式和组件
 */
(function flexible(window, document) {
    let ele = document.documentElement;
    var ua = window.navigator.userAgent;
    // 首次加载即确认为 pc/mobile
    var isPCWeb =  !/DISNEY_MOBILE_/i.test(ua) && !/MicroMessenger/i.test(ua) && !/Mobile/i.test(ua);
    setRemUnit();

    function setRemUnit() {
        let rem;
        if(!isPCWeb) {
            rem = ele.clientWidth < 480 ? ele.clientWidth / 39.3 : 480 / 39.3;
        } else {
            rem = 10;
        }
        ele.style.fontSize = rem + "px";
    }
    
    // reset rem unit on page resize
    window.addEventListener("resize", setRemUnit);
    window.addEventListener("pageshow", function (e) {
        if (e.persisted) {
            setRemUnit();
        }
    });
})(window, document);